import i18n from "../i18n/i18n";
import {CargoType} from "../transportation/models/cargo";

export default class CargoTypeDropdownItems {
    public static getCargoTypeDropdownItems () {
        return [
            {
                id: CargoType.NORMATIVE_TRAILER,
                name: i18n.t("cargoType.NORMATIVE_TRAILER")
            },
            {
                id: CargoType.NORMATIVE_CONTAINER,
                name: i18n.t("cargoType.NORMATIVE_CONTAINER")
            },
            {
                id: CargoType.NORMATIVE_GENERAL_CARGO,
                name: i18n.t("cargoType.NORMATIVE_GENERAL_CARGO")
            },
            {
                id: CargoType.DANGEROUS_TRAILER,
                name: i18n.t("cargoType.DANGEROUS_TRAILER")
            },
            {
                id: CargoType.DANGEROUS_CONTAINER,
                name: i18n.t("cargoType.DANGEROUS_CONTAINER")
            },
            {
                id: CargoType.DANGEROUS_GENERAL_CARGO,
                name: i18n.t("cargoType.DANGEROUS_GENERAL_CARGO")
            },
            {
                id: CargoType.OVERSIZE,
                name: i18n.t("cargoType.OVERSIZE")
            },
            {
                id: CargoType.LORRY,
                name: i18n.t("cargoType.LORRY")
            },
            {
                id: CargoType.OVERSIZE_LORRY,
                name: i18n.t("cargoType.OVERSIZE_LORRY")
            },
            {
                id: CargoType.DANGEROUS_LORRY,
                name: i18n.t("cargoType.DANGEROUS_LORRY")
            },
            {
                id: CargoType.OVERSIZE_TRAILER,
                name: i18n.t("cargoType.OVERSIZE_TRAILER")
            }
        ];
    }
}